module.exports = __webpack_public_path__ + "img/Vector.6a6854fd.svg";